import React from 'react';
import { Redirect, Prompt } from 'react-router-dom';
import ModalEnabled from '../extend/ModalEnabled';
import { serviceAPI } from '../../InterfaceAPI/serviceAPI';
import ServiceWeekly from '../service/ServiceWeekly';
import ServiceCustomWeekly from '../service/ServiceCustomWeekly';
import ServiceOccasion from '../service/ServiceOccasion';
import ServiceEditDetailsModal from '../service/ServiceEditDetailsModal';
import ServiceAddClientModal from '../service/ServiceAddClientModal';
import ServiceAddStaffModal from '../service/ServiceAddStaffModal';
import ServiceAddMenuModal from '../service/ServiceAddMenuModal';
import ServiceDeleteModal from '../service/ServiceDeleteModal';
import ServiceSendDetailsModal from '../service/ServiceSendDetailsModal';
import ServiceSendDetailsSms from '../service/ServiceSendDetailsSms';
import ServiceSendDetailsMessageTypeModal from '../service/ServiceSendDetailsMessageTypeModal';
import ConfirmModal from '../shared/ConfirmModal';
import AddDishModal from '../shared/AddDishModal';
import TextAreaModal from '../shared/TextAreaModal';
import { menuAPI } from '../../InterfaceAPI/menuAPI';
import { purgeIDs, stringfyServerErrors } from '../../helpers/util';
import withSplashMessage from '../splashMessage/withSplashMessage';
import { portionSwitch, maskSlug, adminChefName } from '../../masks';
import SkipWeekModal from '../menuSelection/SkipWeekModal';
import withTracker from '../withTracker';
import Loader from '../shared/Loader';
import SendMenuSmsReminder from '../client/SendMenuSmsReminder';
import { defaultWeeklyTipCents, defaultTravelCents, SERVICE_TYPES} from '../../const'
import { Link } from 'react-router-dom';
import { isOccasion } from '../../helpers/serviceUtil';

class AdminService extends ModalEnabled {
  state = {
    service: {},
    unsaved: false,
    groceryListDisabled: false,
    isLoading: true,
    redirect_to: false,
    isClientEdit: false,
    isMenuEdit: false,
    isStaffEdit: false,
    isDownloading: false,
    refresh: false,
    chefConflicts: []
  };
  mailTo = null;
  staff = null;
  sendSms = false;

  render() {
    if (this.state.redirect_to) return <Redirect to={this.state.redirect_to} />;
    if (this.state.refresh) window.location.reload(false)

    if (this.state.isLoading) return <Loader />;

    const { updateService } = this;
    const { service } = this.state;

    return (
      <div className="cms">
        {this.renderContent()}

        <ServiceEditDetailsModal
          isOpen={this.isOpen('edit-details')}
          closeModal={this.closeModal}
          service={service}
          hideServiceName={[
            SERVICE_TYPES.OCCASION,
            SERVICE_TYPES.COOKING_CLASS,
            SERVICE_TYPES.MARKETING_OCCASION,
          ].includes(service.service_type)}
          updateService={updateService}
        />

        <ServiceDeleteModal
          isOpen={this.isOpen('delete')}
          closeModal={this.closeModal}
          service={service}
          deleteService={this.deleteService}
        />

        <ServiceAddClientModal
          isOpen={this.isOpen('add-client')}
          closeModal={this.closeModal}
          updateService={updateService}
          portionSize={service.portion_size || null}
          feeCents={service.fee_cents || null}
          isOccasion={isOccasion(service)}
        />

        <ServiceAddMenuModal
          isOpen={this.isOpen('add-menu')}
          closeModal={this.closeModal}
          updateService={updateService}
          serviceType={service.service_type}
          service={service}
        />

        <AddDishModal
          addDish={this.addDish}
          isOpen={this.isOpen('add-dish')}
          closeModal={this.closeModal}
        />

        <TextAreaModal
          isOpen={this.isOpen('edit-menu')}
          closeModal={this.closeModal}
          title="Menu"
          value={service.custom_weekly_details}
          onSubmit={value =>
            this.handleTextAreaChange('custom_weekly_details', value)
          }
        />

        <TextAreaModal
          isOpen={this.isOpen('notes')}
          closeModal={this.closeModal}
          title="Public Notes"
          value={service.notes}
          onSubmit={value => this.handleTextAreaChange('notes', value)}
        />

        <ServiceAddStaffModal
          isOpen={this.isOpen('add-staff')}
          closeModal={this.closeModal}
          service={service}
          defaultRole={this.state.defaultRole}
          zipOverride={this.state.zipOverride}
          updateService={updateService}
        />

        <ConfirmModal
          isOpen={this.isOpen('send-staff')}
          closeModal={this.closeModal}
          onSubmit={this.saveThenSendChefInvite}
          heading="Save Service"
          isAdmin={true}
          body="The service must be saved in order to send the service opportunity."
          cta="Save Service"
        />

        <ConfirmModal
          isOpen={this.isOpen('grocery-list')}
          closeModal={this.closeModal}
          onSubmit={this.saveThenOpenGroceryList}
          heading="Save Service"
          isAdmin={true}
          body="The service must be saved in order to view the grocery list."
          cta="Save Service"
        />

        <ConfirmModal
          isOpen={this.isOpen('chef-conflicts')}
          closeModal={this.closeModal}
          onSubmit={this.submitServiceWithoutChecks}
          heading="Chef Schedule Conflicts"
          body=""
          isAdmin={true}
          cta="Confirm"
        >
          <div>
            <p className='p p--red'>
              WARNING: Some chefs have schedule conflicts:
            </p>
            <ul>
              {this.state.chefConflicts.map(conflict => 
                <li>
                  <p className='p'>
                    {`Chef `}
                    <Link 
                      to={`/admin/chef/${conflict.chef_id}`}
                      className="a--blue">
                        {`${conflict.chef_first_name} ${conflict.chef_last_name}`}
                    </Link>
                    {` already has a${conflict.status === 'accepted' ? 'n' :''}  
                    '${conflict.status}' invite for service: `}
                    <Link 
                      to={`/admin/service/${conflict.service_id}/`}
                      onClick={this.forceUpdate}
                      className="a--blue">
                        {conflict.service_name}
                    </Link>
                  </p>
                </li>
              )}
            </ul>
          </div>
        </ConfirmModal>

        <SkipWeekModal
          isOpen={this.isOpen('skip-week')}
          closeModal={this.closeModal}
          skipWeek={this.handleSkipWeek}
        />

        <ServiceSendDetailsModal
          isOpen={this.isOpen('send-details')}
          closeModal={this.closeModal}
          service={service}
          staff={this.staff}
          unsaved={this.state.unsaved}
          sendStaffMail={(staff, emailBody) =>
            this.sendStaffMail(staff, emailBody)
          }
        />

        <ServiceSendDetailsSms
          isOpen={this.isOpen('send-details-sms')}
          closeModal={this.closeModal}
          service={service}
          staff={this.staff}
          unsaved={this.state.unsaved}
          sendStaffSmsInvite={(staff) => this.sendStaffMail(staff, '', true)}
        />

        <ServiceSendDetailsMessageTypeModal
          isOpen={this.isOpen('send-details-message-type')}
          openInviteModal={this.openSendDetailsModal}
          closeModal={this.closeModal}
        />

        <SendMenuSmsReminder
          service={service}
          addMessage={this.props.addMessage}
          isOpen={this.isOpen('send-menu-sms-reminder')}
          closeModal={this.closeModal}
        />

        <Prompt
          when={this.state.unsaved}
          message="You have unsaved data, are you sure?"
        />
      </div>
    );
  }

  renderContent = () => {
    const {
      service,
      unsaved,
      groceryListDisabled,
      isClientEdit,
      isMenuEdit,
      isStaffEdit,
      isDownloading
    } = this.state;

    const {
      updateService,
      submitService,
      setServiceUnsaved,
      updateMenuSelections,
      setRedirect,
      openModal,
      openGroceryList,
      deleteService,
      sendStaffMail,
      downloadChefMaterials
    } = this;
    const { addMessage } = this.props;

    const props = {
      service,
      unsaved,
      groceryListDisabled,
      isClientEdit,
      isMenuEdit,
      isStaffEdit,
      isDownloading,
      updateService,
      submitService,
      setServiceUnsaved,
      updateMenuSelections,
      setRedirect,
      openModal,
      addMessage,
      openGroceryList,
      deleteService,
      sendStaffMail,
      downloadChefMaterials,
      openSendDetailsModal: this.openSendDetailsMessageTypeModal
    };

    switch (service.service_type) {
      case SERVICE_TYPES.WEEKLY:
        return <ServiceWeekly {...props} />;
      case SERVICE_TYPES.CUSTOM_WEEKLY:
        return <ServiceCustomWeekly {...props} />;
      case SERVICE_TYPES.OCCASION:
      case SERVICE_TYPES.MARKETING_OCCASION:
      case SERVICE_TYPES.COOKING_CLASS:
        return (
          <ServiceOccasion {...props} autoPricing autoTitle showRequiredStaff />
        );
      case SERVICE_TYPES.CUSTOM_OCCASION:
        return <ServiceOccasion {...props} />;
      default:
        return 'Loading...';
    }
  };

  addDish = dish => {
    // get the full dish
    menuAPI
      .getDish(dish.id)
      .then(dish => {
        // duplicate the dish
        menuAPI.createDish(this.createServiceDish(dish)).then(dish => {
          // add the duplicate dish
          const { menu_selections = [], id: service_id } = this.state.service;
          const menu_selection = {
            service_id,
            dish,
            dish_id: dish.id,
            notes: null,
            quantity: 1,
            portion: portionSwitch(this.state.service.portion_size)
          };

          menu_selections.push(menu_selection);
          this.updateMenuSelections(menu_selections);
        });
      })
      .catch(error => console.log(error));
  };

  createServiceDish = dish => {
    dish.parent_dish_id = dish.parent_dish_id ? dish.parent_dish_id : dish.id;
    dish.id = null;
    dish.components = purgeIDs(dish.components);
    dish.child_private = true;
    dish.child_name = dish.child_name ? dish.child_name : ' ';

    return dish;
  };

  updateService = (updatedService, state) => {
    this.setState((prevState) => ({
      service: { ...prevState.service, ...updatedService},
      unsaved: true,
      openModal: '',
      ...state
    }))
  };

  deleteService = () => {
    const { service } = this.state;
    serviceAPI
      .deleteService(service.id)
      .then(result => {
        this.props.addMessage({
          className: 'success',
          message: `"Service: ${service.name}" has been deleted.`
        });
        this.setState({ redirect_to: '/admin/services' });
      })
      .catch(result => {
        this.props.addMessage({
          className: 'error',
          message: `There was an error attempting to delete service ${service.name}.`
        });
        this.closeModal();
      });
  };

  handleSkipWeek = (reason = '') => {
    const { service } = this.state;
    serviceAPI
      .skipService(this.state.service.id, reason)
      .then(res => {
        this.props.addMessage({
          className: 'success',
          message: `"Service: ${service.name}" has been skipped.`
        });
        this.setState({ redirect_to: '/admin/services' });
      })
      .catch(err => {
        this.props.addMessage({
          className: 'error',
          message: stringfyServerErrors(err)
        });
        this.closeModal();
      });
  };

  // update the menuSelections in a separate call so we can tag the grocery list as "disabled"
  updateMenuSelections = menu_selections => {
    const service = {
      ...this.state.service,
      menu_selections: [...menu_selections]
    };
    this.setState({
      service,
      unsaved: true,
      groceryListDisabled: true,
      openModal: ''
    });
  };

  handleTextAreaChange = (name, value) => {
    this.updateService({ [name]: value });
  };

  openGroceryList = () => {
    //todo: set back to groceryListDisabled (from unsaved) once logic is nailed down
    if (!this.state.unsaved && this.state.service.id)
      this.setRedirect(this.groceryListPayload(this.state.service.id));
    else this.openModal('grocery-list');
  };

  groceryListPayload = id => {
    return {
      pathname: `/admin/grocery-list/${id}`,
      state: { redirect_url: `/admin/service/${id}` }
    };
  };

  saveThenOpenGroceryList = () => {
    this.triggerRequest()
      .then(service => {
        const redirect_to = this.groceryListPayload(service.id);
        this.setState({ service, redirect_to, unsaved: false });
      })
      .catch(err => {
        console.log(err);
        this.props.addMessage({
          className: 'error',
          message: `Error saving service: ${err}`
        });
        this.setState({ openModal: '' });
      });
  };

  openSendDetailsModal = (sms) =>
    sms ? this.openModal('send-details-sms') : this.openModal('send-details');

  openSendDetailsMessageTypeModal = (staff) => {
    this.staff = staff ? staff : undefined;
    this.openModal('send-details-message-type');
  }

  sendStaffMail = (staff, emailBody, useSms) => {
    this.mailTo = staff;

    if (this.state.service.id) {
      if (this.state.unsaved) {
        // save, then send invite
        this.saveThenSendChefInvite(emailBody, useSms);
      } else {
        // just send invite
        this.sendChefInvitation(emailBody, useSms);
      }
    } else {
      if (Array.isArray(this.state.service.additional_dates) &&
        this.state.service.additional_dates.length > 0) {
        // save and send multiple
          this.batchCreateThenSendChefInviteToAll(emailBody, useSms)
        } else {
        // save and send single
          this.createThenSendChefInvite(emailBody, useSms)
        }
    }
  };

  batchCreateThenSendChefInviteToAll = async (emailBody = null, useSms) => {
    try {
      const response = await this.triggerRequest()
      await this.sendChefInvitations(response.service_ids, emailBody, useSms);
      this.setState({ service: response.service, refresh: true, unsaved: false });
    } catch(err) {
      console.log(err);
      this.props.addMessage({
        className: 'error',
        message: `Error saving service: ${err}`
      });
      this.setState({ openModal: '' });
    }
  }

  createThenSendChefInvite = async (emailBody = null, useSms) => {
    try {
      const service = await this.triggerRequest()
      await this.sendChefInvitations([service.id],emailBody, useSms)
      this.fixServiceDate(service)
      this.setState({ service, refresh: true, unsaved: false });
    } catch(err) {
      console.log(err);
      this.props.addMessage({
        className: 'error',
        message: `Error saving service: ${err}`
      });
      this.setState({ openModal: '' });
    }
  }

  saveThenSendChefInvite = async (emailBody = null, useSms = false) => {
    try {
      const service = await this.triggerRequest()
      this.fixServiceDate(service)
      this.setState({ service, openModal: '', unsaved: false });
      await this.sendChefInvitation(emailBody, useSms)
    } catch(err) {
      console.log(err);
      this.props.addMessage({
        className: 'error',
        message: `Error saving service: ${err}`
      });
      this.setState({ openModal: '' });
    }
  };

  sendChefInvitation = (emailBody, useSms) => {
    const sendMessage = useSms
      ? serviceAPI.sendChefInvitationSms(
          this.state.service.id,
          this.mailTo.chef.id
        )
      : serviceAPI.sendChefInvitation(
          this.state.service.id,
          this.mailTo.chef.id,
          emailBody
        );

      
    // Send Email
    return sendMessage
      .then(this.setChefSentDate)
      .catch(err => {
        console.log(err);
        this.props.addMessage({
          className: 'error',
          message: `Error sending email: ${err}`
        });
      });
  };

  sendChefInvitations = (serviceIds, emailBody, useSms) => {
    let sendInvites = []
    for(const serviceId of serviceIds) {
      if (useSms) {
        sendInvites.push(serviceAPI
        .sendChefInvitationSms(serviceId, this.mailTo.chef.id))
      } else {
        sendInvites.push(serviceAPI
          .sendChefInvitation(serviceId, this.mailTo.chef.id, emailBody))
      }
    }
    return Promise.all(sendInvites)
      .catch(err => {
        console.log(err);
        this.props.addMessage({
          className: 'error',
          message: `Error sending email: ${err}`
        });
      });
  };

  setChefSentDate = ({ invited_chef: staff }) => {
    const invited_chefs = [...(this.state.service.invited_chefs || [])];
    const index = invited_chefs.findIndex(
      invited_chef => invited_chef.id === staff.id || invited_chef.chef.id === staff.chef_id
    );
    invited_chefs[index]['invite_last_sent'] = staff.invite_last_sent;
    invited_chefs[index]['status'] = staff.status;
    const name = adminChefName(invited_chefs[index].chef)
    this.props.addMessage({
      className: 'success',
      message: `Opportunity sent to ${name}.`
    });
    this.updateService(
      { invited_chefs },
      { openModal: '', unsaved: this.state.unsaved }
    );
  };

  downloadChefMaterials = () => {
    const { id, name, date } = this.state.service;
    const filename = `materials-${maskSlug(name)}-${date}.pdf`;
    this.setState({ isDownloading: true });

    serviceAPI
      .downloadChefMaterials(id, filename)
      .then(success => {
        this.setState({ isDownloading: false });
        this.props.addMessage({
          className: 'success',
          message: 'Chef Materials Successfully Downloaded'
        });
      })

      .catch(error => {
        this.setState({ isDownloading: false });
        this.props.addMessage({
          className: 'error',
          message: stringfyServerErrors(error)
        });
      });
  };

  fixServiceDate(service) {
    // Convert 'date'(string) into a Date() object:
    // Simple date strings like '2023-04-10' get converted to the previous day beacuse Date()
    // assumes they are in UTC and then converts them to local time. This line fixed that.
    const date = new Date(service.date) 
    service.date = new Date(date.getTime() + Math.abs(date.getTimezoneOffset()*60000))
  }

  loadService(id) {
    serviceAPI
      .getService(id)
      .then(service => {
        this.fixServiceDate(service)
        this.setState({ service, isLoading: false })
      })
      .catch(this.handleErrorLoading);
  }

  handleErrorLoading = error => {
    const pathname = '/admin/services';
    const redirect_to = { pathname };

    const { state } = this.props.location;
    if (state) {
      const { redirect_url, redirect_payload } = state;
      if (redirect_url) {
        redirect_to.pathname = redirect_url;
      }

      if (redirect_payload) redirect_to.state = { ...redirect_payload };
    }
    this.props.addMessage({
      className: 'error',
      message: stringfyServerErrors(error)
    });
    this.setState({ redirect_to, isLoading: false });
  };

  submitService = async () => {
    const { service } = this.state;

    if (service.invited_chefs && service.invited_chefs.length > 0) {
      const response = await this.checkForConflicts(service)

      if (response.conflicts.length > 0) {
        this.setState({ chefConflicts: response.conflicts })
        this.openModal('chef-conflicts');
        return
      }
    } 
    this.submitServiceWithoutChecks()
  }

  submitServiceWithoutChecks = () => {
    const { service } = this.state;
    const refresh = true;
    const successMessage = service.id
      ? {
          className: 'success',
          message: `"${service.name}" service has been updated.`
        }
      : {
          className: 'success',
          message: `"${service.name}" service has been created.`
        };

    this.triggerRequest()
      .then(service => {
        this.props.addMessage(successMessage);
        this.fixServiceDate(service)
        this.setState({ service, refresh, unsaved: false });
      })
      .catch(err =>
        this.props.addMessage({
          className: 'error',
          message: `Error saving service: ${err}`
        })
      );
  };

  checkForConflicts(service) {
    const invited_chefs = service.invited_chefs.map(sic => sic.chef.id)

    return serviceAPI.getChefConflicts(invited_chefs, service.start_time, service.end_time, service.id)
  }  

  triggerRequest() {
    const service = this.state.service
    if (Array.isArray(service.additional_dates) && service.additional_dates.length > 0) {
      return serviceAPI.batchCreateServices(service);
    } else {
      return this.state.service.id
        ? serviceAPI.updateService(service)
        : serviceAPI.createService(service);
    }
  }

  generateNewService(service_type) {
    let serviceState = { 
      service_type,
      tip_cents: (["occasion","marketing_occasion"].includes(service_type) ? 0 : defaultWeeklyTipCents),
      travel_cents: defaultTravelCents,
      menu_selections: [],
      override_fields: {}
    };

    if (service_type === "occasion") {
        serviceState["notes"] = `
        <p><strong>PRICING:</strong></p>\n
        <p><strong>ALLERGIES:</strong></p>\n
        <p><strong>STAFF:</strong></p>\n
        <ul>\n
          <li><strong>Chef needs:</strong></li>\n
          <li><strong>Server needs:</strong>\n
            <ul>\n
              <li><strong>Ordered? Confirmed?</strong></li>\n
            </ul>\n
          </li>\n
        </ul>\n
        <p><strong>DETAILS:</strong></p>\n
        <ul>\n
          <li><strong>Time:</strong>\n
            <ul>\n
              <li><strong>Confirmed?</strong></li>\n
            </ul>\n
          </li>\n
          <li><strong>Guest Count:</strong>\n
            <ul>\n
              <li><strong>Confirmed?</strong></li>\n
            </ul>\n
          </li>\n
          <li><strong>Menu Notes/ Preferences:</strong>\n
            <ul>\n
              <li><strong>Confirmed?</strong></li>\n
            </ul>\n
          </li>\n
        </ul>\n
        <p><strong>CLIENT INFO:</strong></p>\n
        <p><em>New Client:</em></p>\n
        <ul>\n
          <li><strong>Number:</strong></li>\n
          <li><strong>Email:</strong></li>\n
          <li><strong>Address:</strong></li>\n
        </ul>\n
        <p><strong>CONFIRM PRICING IN LEFT MODULE IS CORRECT</strong></p>`
    }

    this.setState({
      service: serviceState,
      isLoading: false
    });
  }

  setServiceUnsaved = (unsaved = false, callback = null) => {
    this.setState({ unsaved }, callback);
  };

  setRedirect = redirect_to => {
    this.setState({ redirect_to });
  };

  componentDidMount() {
    const { id, type } = this.props.match.params;
    const { state } = this.props.location;

    if (state && state.service) {
      // try to load from react-router state

      // also a dish in the state? swap it in to service.menu_selections
      if (state.dish) {
        const index = state.service.menu_selections.findIndex(
          selection => selection.dish_id === state.dish.id
        );
        if (index >= 0)
          state.service.menu_selections[index].dish = { ...state.dish };
      }

      // set state
      this.setState({
        service: { ...state.service },
        unsaved: true,
        isLoading: false
      });

      // Clear history state. If the user refreshes or saves, we don't want to keep showing
      // the state that was sent from the link that got us here.
      this.props.history.replace()

    } else if (
      id === 'create' &&
      Object.values(SERVICE_TYPES).includes(type)
    )
      this.generateNewService(type);
    else if (id > 0) this.loadService(id);
  }
}
export default withSplashMessage(withTracker(AdminService));



// WEBPACK FOOTER //
// ./src/components/admin/AdminService.js